function SvgIdCard() {
  return (
    <svg width="28" height="18" viewBox="0 0 28 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M26.9488 1.75899V15.8597C26.9488 16.5253 26.4062 17.0679 25.7406 17.0679H1.75703C1.0842 17.0679 0.548828 16.5253 0.548828 15.8597V1.75899C0.548828 1.09339 1.0842 0.550781 1.75703 0.550781H25.7406C25.9649 0.550781 26.1747 0.615868 26.3555 0.724411C26.71 0.926959 26.9488 1.31767 26.9488 1.75899Z"
        fill="white"
      />
      <path d="M26.9488 3.73145H0.548828V7.07379H26.9488V3.73145Z" fill="currentColor" />
      <path
        d="M9.50136 10.1045H3.61706C3.32104 10.1045 3.08105 10.3444 3.08105 10.6405V13.9979C3.08105 14.294 3.32104 14.5339 3.61706 14.5339H9.50136C9.79741 14.5339 10.0374 14.294 10.0374 13.9979V10.6405C10.0374 10.3444 9.79741 10.1045 9.50136 10.1045Z"
        fill="currentColor"
      />
      <path
        d="M24.4182 13.0447V14.2963C24.4182 14.4266 24.3096 14.535 24.1794 14.535H14.9549C14.8175 14.535 14.709 14.4265 14.709 14.2963V13.0447C14.709 12.9144 14.8175 12.806 14.9549 12.806H24.1794C24.3096 12.806 24.4182 12.9144 24.4182 13.0447ZM24.4182 9.8686V11.1203C24.4182 11.2505 24.3096 11.359 24.1794 11.359H18.5724C18.4349 11.359 18.3264 11.2505 18.3264 11.1203V9.8686C18.3264 9.73838 18.4349 9.62988 18.5724 9.62988H24.1794C24.3096 9.62988 24.4182 9.73838 24.4182 9.8686Z"
        fill="#D8D8D8"
      />
      <path
        d="M25.7418 17.6172H1.75823C0.788744 17.6172 0 16.8284 0 15.859V1.75823C0 0.788744 0.788744 0 1.75823 0H25.7418C26.7113 0 27.5 0.788744 27.5 1.75823V15.859C27.5 16.8284 26.7113 17.6172 25.7418 17.6172ZM1.75823 1.10001C1.39541 1.10001 1.1 1.39542 1.1 1.75823V15.859C1.1 16.2221 1.39541 16.5172 1.75823 16.5172H25.7418C26.1046 16.5172 26.4 16.2221 26.4 15.859V1.75823C26.4 1.39542 26.1046 1.10001 25.7418 1.10001H1.75823Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIdCard;
